<template>
  <div>
    <!-- web端 -->
    <ul class="commentsUl_flat_update_pc">
      <template v-for="(item, index) in new_comments_list">
        <li
          class="commentsItem_pc"
          v-if="item.comment_approved && item.status == 'publish'"
          :key="item.comment_ID"
        >
          <!-- left -->
          <div class="name_country card_left">
            <!-- 姓名 -->
            <div class="name secondary_title">{{ item.name }}</div>
            <!-- 国家 -->
            <span
              class="country"
              v-if="comment.comment_country == 'yes' && item.country"
            >
              <country-flag :country="item.country=='UK'?'GB':item.country" size="small" />
              {{ item.country }}
            </span>
          </div>

          <!-- right -->
          <div class="card_right">
            <!-- 评分 -->
            <div class="star">
              <v-commentsstar
                :disabled="true"
                :average_rating="item.rating"
                font_size="18"
              ></v-commentsstar>
            </div>
            <!-- 评论内容 -->
            <div
              class="comment_content page_text_font"
              v-text="item.content"
            ></div>
            <!-- 图片 -->
            <div class="comment_photo" v-if="item.gallery.length">
              <v-lazy-img
                v-for="(subitem, subindex) in item.gallery"
                :key="subitem.ID"
                :src="subitem.thumbnail"
                :data-url="subitem.url"
                @click.native="showBigImg(item.gallery, subindex)"
                alt
              />
            </div>
            <!-- 评论时间和点赞 -->
            <div class="time_giveLike">
              <!-- 评论时间 -->
              <span class="date" v-if="comment.comment_time == 'yes'">{{
                item.comment_date
              }}</span>
              <!-- 点赞 -->
              <div style="display: flex">
                <!-- 暂时屏蔽举报按钮 -->
                <!-- <div class="report_btn">
                  <span
                    class="report secondary_title"
                    v-show="item.abuse_show"
                    @click="click_abuse(item, index)"
                    >{{ $t("comment.report_as_inappropriate") }}</span
                  >
                  <span
                    class="report secondary_title"
                    v-show="!item.abuse_show"
                    >{{ $t("comment.this_review_has_been_reported") }}</span
                  >
                </div> -->
                <div class="giveLike">
                  <i
                    @click="comment_helpful(item, index)"
                    class="iconfont icon-dianzan"
                    style="cursor: pointer; font-size: 16px"
                    :style="
                      !item.help_show
                        ? 'color:#52C41A;pointer-events: none;'
                        : ''
                    "
                  >
                  </i>
                  <div
                    class="giveLike_number"
                    v-if="comment.comment_account == 'yes'"
                  >
                    {{ item.like_account || 0 }}
                  </div>
                </div>
              </div>
            </div>
            <!-- 商家回复 -->
            <div class="reply">
              <v-commentReply
                v-if="item.reply && item.reply.length"
                :reply="item.reply"
                style="padding: 0"
              ></v-commentReply>
            </div>
          </div>
        </li>
      </template>
      <div
        v-if="next_page <= last_page"
        style="text-align: center; padding-top: 40px; cursor: pointer;"
      >
        <span class="more_reviews_btn secondary_title" @click="get_comment(next_page, 'popup')">
          {{ $t("comment.show_more_reviews") }}
        </span>
      </div>
    </ul>
    <!-- 移动端 -->
    <ul class="commentsUl_flat_update_mb">
      <template v-for="(item, index) in new_comments_list">
        <li
          class="commentsItem_mb"
          v-if="item.comment_approved && item.status == 'publish' && index < 2"
          :key="item.comment_ID"
          :style="index == 1 ? 'border:none' : ''"
        >
          <!-- 姓名和评分 -->
          <div class="name_star">
            <div class="name secondary_title">{{ item.name }}</div>
            <div class="star">
              <v-commentsstar
                :disabled="true"
                :average_rating="item.rating"
                font_size="18"
              ></v-commentsstar>
            </div>
          </div>
          <!-- 评论时间和国家 -->
          <div class="comment_time secondary_title">
            <span class="date" v-if="comment.comment_time == 'yes'">{{
              item.comment_date
            }}</span>
            <span
              class="country"
              v-if="comment.comment_country == 'yes' && item.country"
            >
              <country-flag :country="item.country=='UK'?'GB':item.country" size="small" />
              {{ item.country }}
            </span>
          </div>
          <!-- 评论内容 -->
          <div
            class="comment_content page_text_font"
            v-text="item.content"
          ></div>
          <!-- 图片 -->
          <div class="comment_photo" v-if="item.gallery.length">
            <v-lazy-img
              v-for="(subitem, subindex) in item.gallery"
              :key="subitem.ID"
              :data-url="subitem.url"
              @click.native="showBigImg(item.gallery, subindex)"
            />
          </div>
          <!-- 商家回复 -->
          <div class="reply">
            <v-commentReply
              v-if="item.reply && item.reply.length"
              :reply="item.reply"
              style="padding: 0 0 8px"
            ></v-commentReply>
          </div>
          <!-- 点赞 -->
          <div class="giveLike">
            <i
              @click="comment_helpful(item, index)"
              class="iconfont icon-dianzan"
              style="cursor: pointer; font-size: 14px"
              :style="
                !item.help_show ? 'color:#52C41A;pointer-events: none;' : ''
              "
            >
            </i>
            <div
              class="giveLike_number"
              v-if="comment.comment_account == 'yes'"
            >
              {{ $t("comment.helpful") }} ({{ item.like_account || 0 }})
            </div>
          </div>
        </li>
      </template>
      <div v-if="new_comments_list && new_comments_list.length > 2" class="more_btn" @click="popup_show = true">View All ></div>
    </ul>
    <!-- 评论弹窗 -->
    <div v-if="popup_show" class="commentsUl_flat_update_popup">
      <!-- 头部 -->
      <div class="icon_reviewsNum">
        <i @click="popup_show = false" class="iconfont icon-a-ziyuan10"></i>
        <div class="reviewsNum">Reviews ({{ review_count }})</div>
      </div>
      <!-- 评论内容 -->
      <div class="popup_content">
        <v-comments-write-box
          :review_count="review_count"
          :average_rating="average_rating"
          :rating_count="rating_count"
          :product_id="product_id"
          :product_review="product_review"
        ></v-comments-write-box>

        <ul class="commentsUl_flat_update_mb">
          <template v-for="(item, index) in new_comments_list">
            <li
              class="commentsItem_mb"
              v-if="item.comment_approved && item.status == 'publish'"
              :key="item.comment_ID"
            >
              <!-- 姓名和评分 -->
              <div class="name_star">
                <div class="name secondary_title">{{ item.name }}</div>
                <div class="star">
                  <v-commentsstar
                    :disabled="true"
                    :average_rating="item.rating"
                    font_size="18"
                  ></v-commentsstar>
                </div>
              </div>
              <!-- 评论时间和国家 -->
              <div class="comment_time secondary_title">
                <span class="date" v-if="comment.comment_time == 'yes'">{{
                  item.comment_date
                }}</span>
                <span
                  class="country"
                  v-if="comment.comment_country == 'yes' && item.country"
                >
                  <country-flag :country="item.country=='UK'?'GB':item.country" size="small" />
                  {{ item.country }}
                </span>
              </div>
              <!-- 评论内容 -->
              <div
                class="comment_content page_text_font"
                v-text="item.content"
              ></div>
              <!-- 图片 -->
              <div class="comment_photo" v-if="item.gallery.length">
                <v-lazy-img
                  v-for="(subitem, subindex) in item.gallery"
                  :key="subitem.ID"
                  :src="subitem.thumbnail"
                  :data-url="subitem.url"
                  @click.native="showBigImg(item.gallery, subindex)"
                  alt
                />
              </div>
              <!-- 商家回复 -->
              <div class="reply">
                <v-commentReply
                  v-if="item.reply && item.reply.length"
                  :reply="item.reply"
                  style="padding: 0 0 8px"
                ></v-commentReply>
              </div>
              <!-- 点赞 -->
              <div class="giveLike">
                <i
                  @click="comment_helpful(item, index)"
                  class="iconfont icon-dianzan"
                  style="cursor: pointer; font-size: 14px"
                  :style="
                    !item.help_show ? 'color:#52C41A;pointer-events: none;' : ''
                  "
                >
                </i>
                <div
                  class="giveLike_number"
                  v-if="comment.comment_account == 'yes'"
                >
                  {{ $t("comment.helpful") }} ({{ item.like_account || 0 }})
                </div>
              </div>
            </li>
          </template>
        </ul>
        <div
          v-if="next_page <= last_page"
          style="text-align: center; padding-bottom: 20px; cursor: pointer;"
        >
          <span
            class="more_reviews_btn secondary_title"
            @click="get_comment(next_page, 'popup')"
          >
            {{ $t("comment.show_more_reviews") }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vCommentsstar from "./commentsstar";
import vCommentReply from "./commentReply.vue";
import vCommentsWriteBox from "./commentsWriteBox";

export default {
  props: [
    "comment_mode",
    "comment",
    "new_comments_list",
    "showBigImg",
    "comment_helpful",
    "click_abuse",
    "review_count",
    "average_rating",
    "rating_count",
    "product_id",
    "product_review",
    "next_page",
    "last_page",
    "get_comment",
  ],
  data() {
    return {
      popup_show: false,
    };
  },
  components: {
    vCommentsstar,
    CountryFlag: resolve => {require(['vue-country-flag'], resolve)},
    vCommentReply,
    vCommentsWriteBox,
  },
  watch: {
    new_comments_list(newV) {
      console.log(newV, "newVnewV");
    },
  },
};
</script>
<style scoped lang='scss'>
.commentsUl_flat_update_pc {
  padding: 0;
  margin-bottom: 20px;
  .commentsItem_pc {
    display: flex;
    padding: 20px 24px;
    box-shadow: 0px 2px 16px 0px #f1f2f3;
    border-radius: 8px;
    margin-bottom: 20px;
    // left
    .card_left {
      width: 12%;
    }
    .name_country {
      .name {
        font-size: 16px;
        font-weight: bold;
        line-height: 24px;
      }
      .country {
        font-weight: bold;
        .flag {
          box-sizing: content-box;
          border: 1px solid #dedede;
        }
      }
    }
    // right
    .card_right {
      width: 88%;
    }
    .star {
      margin-bottom: 10px;
    }
    .comment_content {
      line-height: 24px;
      margin-bottom: 12px;
    }
    .comment_photo {
      margin-bottom: 20px;
      img {
        padding: 0;
        margin: 0;
        -webkit-tap-highlight-color: transparent;
        width: 52px;
        height: 52px;
        display: inline-block;
        background: #f2f2f2;
        box-sizing: border-box;
        cursor: zoom-in;
        object-fit: cover;
      }
    }
    .time_giveLike {
      display: flex;
      justify-content: space-between;
      .date {
        color: #999999;
      }
      .giveLike {
        display: flex;
        align-items: center;
        .giveLike_number {
          margin-left: 5px;
          font-size: 12px;
        }
      }
    }
    .reply {
      &::v-deep {
        .comment-reply-main {
          .time {
            display: none !important;
          }
        }
      }
    }
  }
}

.commentsUl_flat_update_mb {
  padding: 0;
  margin-bottom: 20px;
  display: none;
  .commentsItem_mb {
    color: #000;
    margin: 0;
    -webkit-tap-highlight-color: transparent;
    outline: 0;
    list-style: none;
    position: relative;
    padding: 20px 20px 20px 0;
    &:not(:last-child) {
      border-bottom: 1px solid #dedede;
    }
    .name_star {
      display: flex;
      align-items: center;
      .name {
        font-size: 15px;
        font-weight: bold;
      }
      .star {
        margin: 0 0 0 14px;
        &::v-deep .el-rate__icon {
          font-size: 13px !important;
        }
      }
    }
    .comment_time {
      margin: 15px 0;
      color: #999999;
      font-size: 13px;
    }
    .country {
      margin-left: 5px;
      .flag {
        box-sizing: content-box;
        border: 1px solid #dedede;
        margin-right: -14px;
      }
    }
    .comment_content {
      font-size: 14px;
      line-height: 19px;
      margin-bottom: 13px;
    }
    .comment_photo {
      width: 50%;
      margin-bottom: 20px;
      img {
        padding: 0;
        margin: 0;
        -webkit-tap-highlight-color: transparent;
        width: 100%;
        height: 100%;
        display: inline-block;
        background: #f2f2f2;
        box-sizing: border-box;
        cursor: zoom-in;
        object-fit: cover;
      }
    }
    .reply {
      &::v-deep {
        .comment-reply-main {
          li {
            border: none;
            padding: 0;
          }
          .time {
            display: none !important;
          }
        }
      }
    }
    .giveLike {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .giveLike_number {
        margin-left: 6px;
      }
    }
  }
  .more_btn {
    cursor: pointer;
    text-align: center;
    color: #999999;
  }
}

.commentsUl_flat_update_popup {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100vh;
  background-color: #ffffff;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  .icon_reviewsNum {
    padding: 17.5px 15px;
    box-shadow: 0px 1px 0px 0px #eaeaea;
    i {
      font-size: 20px;
      position: absolute;
      font-weight: bold;
    }
    .reviewsNum {
      text-align: center;
      width: 100%;
      font-size: 18px;
      font-weight: bold;
    }
  }
  .popup_content {
    padding: 0 15px;
    &::v-deep {
      .writebox.product_review_write {
        .writeboxcontent {
          margin-top: 20px !important;
          .athena_review {
            display: none !important;
          }
        }
      }
    }
  }
}

@media screen and(max-width: 767px) {
  .commentsUl_flat_update_mb {
    display: block;
  }
  .commentsUl_flat_update_pc {
    display: none;
  }
  .commentsUl_waterfall {
    column-count: 1 !important;
  }
}
</style>